<!-- eslint-disable max-len -->
<template>
    <div class="info-panel">
        <div class="content-drawer" :class="{ active: isDrawerActive }">
            <div class="content-drawer__inner">
                <h3>How it works</h3>

                <h4>What is considered a freight booking?</h4>
                <p>A vehicle longer than 6 metres or higher than 2.6 metres or if you are shipping commercial goods or tools, you are in the right place.</p>

                <h4>Are you a new customer?</h4>
                <p>Bookings can be made through the New Customer portal. Our commercial team are also available to offer bespoke solutions to meet your business needs. <a href="/freight/business-information/contact-us/">Talk to us</a>.</p>

                <h4>Have you sailed with us before?</h4>
                <p>If so please login through the existing customer or please reach out <a href="/freight/business-information/contact-us/">here</a> if you have any questions.</p>
            </div>
        </div>
        <VBtn class="v-btn--toggle" @click="isDrawerActive = !isDrawerActive">
            <span>{{ btnText }} <SvgIcon icon="chevron-down" width="1rem" height="1rem" /></span>
        </VBtn>
    </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { VBtn } from "v-ferry-components";
import SvgIcon from "@/components/icons/SvgIcon.vue";

interface Props {
    btnText: string;
}

defineProps<Props>();

const isDrawerActive = ref(false);
</script>

<style lang="scss" scoped>
.info-panel {
    $prefix: ".info-panel";
    display: flex;
    width: 100%;

    --v-btn-height: 40px;

    @include media-breakpoint-down(xl) {
        flex-direction: column;
    }

    @include media-breakpoint-up(xl) {
        position: absolute;
        left: 100%;
        max-width: var(--entry-form__info-panel__max-width);
        height: 100%;
    }

    .v-btn--toggle {
        display: flex;
        width: 100%;
        height: var(--v-btn-height);
        background-color: var(--c-secondary);
        color: var(--c-primary);
        border-top-left-radius: 0;
        overflow: hidden;

        @include media-breakpoint-down(xl) {
            border-top-right-radius: 0;
        }

        @include media-breakpoint-up(xl) {
            width: var(--v-btn-height);
            height: 100%;
            border-bottom-left-radius: 0;
        }

        span {
            display: flex;
            align-items: center;
            gap: 8px;
            font-weight: bold;
            white-space: nowrap;

            @include media-breakpoint-up(xl) {
                transform: rotateZ(-90deg);
            }
        }

        &:enabled {
            &:hover {
                background-color: var(--c-secondary-hover);
            }
        }
    }

    .content-drawer {
        $prefix: ".content-drawer";
        display: flex;
        box-shadow: var(--box-shadow);
        overflow: hidden;

        @include media-breakpoint-down(xl) {
            flex-direction: column;
            max-height: 0;
            transition: max-height 0.4s ease;
        }

        @include media-breakpoint-up(xl) {
            max-width: 0;
            transition: max-width 0.4s ease;
        }

        &.active {
            @include media-breakpoint-down(xl) {
                max-height: 100vh;
            }

            @include media-breakpoint-up(xl) {
                max-width: 100vw;
            }

            + .v-btn--toggle {
                span {
                    svg {
                        transform: rotateZ(180deg);
                    }
                }
            }
        }

        &__inner {
            display: flex;
            flex-direction: column;
            flex: 1 0 auto;
            padding: 20px;
            background-color: var(--c-background);
            overflow-y: auto;

            @include media-breakpoint-down(xl) {
                flex: 0 1 auto;
                border-top: 2px solid var(--c-secondary);
            }
            
            @include media-breakpoint-up(xl) {
                max-width: calc(var(--entry-form__info-panel__max-width) - 40px);
                border-left: 2px solid var(--c-secondary);
                padding: 30px;
            }

            h3 {
                color: var(--c-accent);
            }

            h4 {
                font-size: 1rem;
            }

            h3, p {
                margin: 0;
                
                + h4, + p {
                    margin-top: 15px;
                }
            }
        }
    }

    .v-btn--toggle {
        box-shadow: var(--box-shadow);
    }
}
</style>
